module.exports = __webpack_public_path__ + "img/Recurso 9.002e0c3c.png";